
<template>
    <v-data-table object :headers="tableHeaders" :items="tableItems" dense hide-default-footer :items-per-page="1000" style="height: 150px; overflow-y: auto">
        
        <template v-slot:item="props">
            <tr>
            <!-- <td style="height: 25px" v-for="k in tableHeaders" :key="k.text" :class="checkAlignment(k.align)">{{ props.item[k.value] }}</td> -->
                <td style="height: 25px" class="text-left">{{props.item.name}}</td>
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 100px" type="number" min="-1" v-model.number="props.item.Werte[0]" @change="$store.dispatch('resetAndRedraw')"></td>            
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 100px" type="number" min="-1" v-model.number="props.item.Werte[1]" @change="$store.dispatch('resetAndRedraw')"></td>
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 100px" type="number" min="-1" v-model.number="props.item.Werte[2]" @change="$store.dispatch('resetAndRedraw')"></td>
                <td><v-icon color="red" small @click="deleteItem(props.item)">clear</v-icon></td>
            </tr>
        </template> 
        <template v-slot:body.prepend>
            <tr style="background: #C8E6C9">
                <td style="height: 25px" class="text-left">neues Gelenk</td>
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 100px" min="-1" type="number" v-model.number="nGelenk.Werte[0]" ></td>         
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 100px" min="-1" type="number" v-model.number="nGelenk.Werte[1]" ></td>
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 100px" min="-1" type="number" v-model.number="nGelenk.Werte[2]" ></td>
                <!--<td style="height: 25px" class="text-right"><input style="text-align:right;" type="select"></td>-->
                <td><v-btn small icon @click="apply()"><v-icon color="green" small>add_box</v-icon></v-btn></td>
            </tr>
        </template>                      
    </v-data-table>
</template>

<script>
import Gelenk from '../../js/Gelenk'
/* eslint-disable */

export default {
    data(){
        return{
            nGelenk: new Gelenk,
            initStatus: this.$store.initStatus,
            tableHeaders: [
                    { text: 'Name', align: 'left', value: 'name'},
                    { text: 'N-Wert [N/m]', align: 'right', sortable: false},
                    { text: 'Q-Wert [N/m]', align: 'right', sortable: false},
                    { text: 'M-Wert [Nm/rad]', align: 'right', sortable: false}
                ],
        }
    },
    computed: {
        tableItems() { return this.$store.state.StatikSystem.Gelenkliste},
    },
    methods: {
        apply(){
            debugger
            this.$store.state.newGelenk = true
            // this.$store.state.StatikSystem.newKnoten(this.nKnoten.x,this.nKnoten.y,this.nKnoten.Auflager)
            this.$store.commit('GelenkDialogApply', this.nGelenk)
            this.nGelenk = new Gelenk
            // this.nGelenk.Werte[0] = 0
            // this.nGelenk.Werte[1] = 0
            // this.nGelenk.Werte[2] = 0
        },
        deleteItem(payload){
            this.$store.commit('GelenkDialogDelete',payload)
        }
    }
}
</script>

<style scoped>
    select {
        padding-left: 5px; 
        padding-right: 5px;
        cursor: pointer;
        border-style: solid;
    }
    input {
        cursor: pointer;
        border-style: solid;
        border-width: thin;
    }
    .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 25px;
    }   
</style>